import {db} from './firebase.js'

export default {

    async getForms() {
      return await db
        .get()
        .then((snapshot) => {
          const tempDoc = [];
          snapshot.forEach((doc) => {
            tempDoc.push({ db_id: doc.id, ...doc.data() });
          });
          return tempDoc.reverse();
        });
    },
  
    async newRow(data) {
      return await db.add(data);
    },
  
    async deleteRow(id) {
      return await db.doc(id).delete();
    },
  
    async updateRow(id, data) {
      return await db.doc(id).update(data);
    },
  
    async getRow(id) {
      return await db.doc(id).get().then((doc) => {
        return doc.data();
      });
    }
  
  }